import type { SkillManifest, TestRun } from "@ai-sales/contracts";
import { assessReleaseEvidence } from "./release-evidence.js";
import { CheckIcon } from "./icons.js";

const evidenceLabels = {
  current_passed: "当前冻结测试集全部通过",
  current_failed: "最近运行存在失败",
  stale: "测试证据已过期",
  legacy_passed: "历史兼容测试已通过",
  none: "当前版本尚无测试证据"
} as const;

export function ReleaseEvidenceSummary({ skill, runs }: { skill: SkillManifest; runs: TestRun[] }) {
  const evidence = assessReleaseEvidence(skill, runs);
  const current = evidence.status === "current_passed";
  const run = evidence.run;
  if (!run) return <p className="muted">{evidenceLabels.none}。</p>;
  const suite = skill.modules?.testSuite;
  return <div className="test-summary">
    <span className={current ? "success-mark" : "failure-mark"}><CheckIcon /></span>
    <strong>{evidenceLabels[evidence.status]}</strong>
    <p>{run.passed} 通过 · {run.failed} 失败</p>
    <small>{formatEvidenceTime(run.completedAt ?? run.createdAt)} · {run.model ?? "未记录模型"}</small>
    {suite?.datasetId ? <small>运行测试集 {run.testDatasetVersion ?? "旧格式"} · 当前 {suite.datasetVersion}</small> : null}
    {evidence.status === "legacy_passed" ? <small>只可用于历史回滚或重新启用；新发布需创建产品化版本。</small> : null}
  </div>;
}

function formatEvidenceTime(value: string): string {
  return new Intl.DateTimeFormat("zh-CN", { dateStyle: "medium", timeStyle: "short" }).format(new Date(value));
}
